import React from "react";

interface ActionButtonProps {
  type: string;
  onClick?: () => void;
  text: string;
  className: string;
}

const ActionButton = ({ type, onClick, text, className }: ActionButtonProps) => {
  // Combines the provided className with the type for additional styling
  const classNames = `${className} button ${type}`;

  return (
    <button className={classNames} onClick={onClick}>
      {text}
    </button>
  );
};

export default ActionButton;